import { ENVS } from "config";
import type { PostHogConversationsApi } from "types/posthog-conversations";

import {
  clickPosthogConversationsLauncherIfPresent,
  isPosthogConversationsPanelOpen,
  waitForPosthogConversationsPanelOpen,
  waitForPosthogConversationsWidgetVisible,
} from "./posthogConversationsDom";
import { persistPosthogConversationsWidgetOpen } from "./posthogConversationsStorage";

export const openPosthogConversations = async (
  conversations: PostHogConversationsApi
): Promise<boolean> => {
  persistPosthogConversationsWidgetOpen(ENVS.posthogKey);
  conversations.show();

  const visible = await waitForPosthogConversationsWidgetVisible(conversations);
  if (!visible) {
    return false;
  }

  if (!isPosthogConversationsPanelOpen()) {
    clickPosthogConversationsLauncherIfPresent();
  }

  return waitForPosthogConversationsPanelOpen();
};

export const closePosthogConversations = (conversations: PostHogConversationsApi): void => {
  conversations.hide();
};
